<template>
  <LoadingBlock :loading="loading">
    <form @submit.prevent="submit">
      <div v-if="!targetOptions.length" class="text-muted mb-3">
        Нет других компаний, где вы владелец.
      </div>
      <template v-else>
        <div class="mb-3">
          <label class="form-label">Целевая компания</label>
          <Select v-model="targetCompanyId" :options="targetOptions" optionLabel="name" optionValue="id"
                  placeholder="Выберите компанию" style="width: 100%"/>
          <div class="form-text">Показаны компании, где вы владелец.</div>
        </div>

        <div v-if="targetCompany" class="alert alert-warning mb-3" role="alert">
          Все сертификаты компании «{{ sourceCompany?.name || 'текущая' }}» будут скопированы
          в «{{ targetCompany.name }}». Сертификаты с номерами, которые уже есть в «{{ targetCompany.name }}»,
          будут пропущены. Товары привяжутся по коду поставщика.
          <div class="small mt-2 mb-0">
            Выгрузки в Озон не копируются — в целевой компании их нужно запустить заново.
            Повторный запуск безопасен: дублей не будет, докопируется только новое.
          </div>
        </div>
      </template>

      <p v-if="loading && waitingTask" class="text-center text-muted">Копирование запущено, открываем задачу…</p>

      <div class="text-center mt-4">
        <button type="submit" class="btn btn-primary" :disabled="!targetCompanyId || loading">
          Скопировать
        </button>
      </div>
    </form>
  </LoadingBlock>
</template>

<script>
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Select} from "primevue";
import {copyToCompany} from "@/api/certificate";
import {user} from "@/data/user";
import {Message, Messages} from "@/data/messages";
import {CERTIFICATE_COPY_TASK, isCompanyOwner, parseRequestError} from "@/data/certificate";
import {getLatestTaskId, openStartedTask} from "@/helpers/task";

export default {
  name: "CertificateCopyToCompanyForm",
  components: {LoadingBlock, Select},
  emits: ['started'],
  data() {
    return {
      loading: false,
      waitingTask: false,
      targetCompanyId: null,
    }
  },
  computed: {
    sourceCompany() {
      return user.companies.find((company) => company.id === user.active_company) || null
    },
    targetOptions() {
      return user.companies.filter((company) => company.id !== user.active_company
          && isCompanyOwner(company, user.user_id))
    },
    targetCompany() {
      return this.targetOptions.find((company) => company.id === this.targetCompanyId) || null
    },
  },
  methods: {
    reset() {
      this.targetCompanyId = null
      this.loading = false
      this.waitingTask = false
    },
    errorText(e) {
      const status = e?.response?.status
      if (status === 403) {
        return 'Нет доступа: нужно быть участником текущей компании и владельцем целевой'
      }
      if (status === 422) {
        return parseRequestError(e, 'Компания-источник и целевая компания совпадают')
      }
      return parseRequestError(e, 'Не удалось запустить копирование')
    },
    async submit() {
      if (!this.targetCompany || this.loading) {
        return
      }
      const target = this.targetCompany
      this.loading = true
      const message = new Message()
      try {
        const sourceId = await user.getActiveCompany()
        // задача создаётся в целевой компании
        const previousTaskId = await getLatestTaskId(target.id, CERTIFICATE_COPY_TASK)
        const result = await copyToCompany(sourceId, target.id)
        if (result.status === 202 || result.status === 200 || result.status === 201) {
          message.type = 'success'
          message.autoremove = 15
          message.text = `Копирование запущено. Задача — в компании «${target.name}»`
          Messages.list.push(message)
          this.$emit('started')
          this.waitingTask = true
          // задача в другой компании, поэтому список задач (он по активной компании) не открываем
          await openStartedTask(this.$router, target.id, CERTIFICATE_COPY_TASK, previousTaskId, false)
          this.reset()
        } else {
          message.type = 'failure'
          message.text = 'Не удалось запустить копирование'
          Messages.list.push(message)
        }
      } catch (e) {
        message.type = 'failure'
        message.text = this.errorText(e)
        Messages.list.push(message)
      }
      this.loading = false
      this.waitingTask = false
    },
  },
}
</script>
